import { render, staticRenderFns } from "./component-select.vue?vue&type=template&id=20df7b23"
import script from "./component-select.vue?vue&type=script&setup=true&lang=js"
export * from "./component-select.vue?vue&type=script&setup=true&lang=js"
import style0 from "./component-select.vue?vue&type=style&index=0&id=20df7b23&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports